import { W as WuiTextarea$1, d as defineCustomElement$1 } from './p-B3mB3mC8.js';

const WuiTextarea = WuiTextarea$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTextarea, defineCustomElement };
